export default {
  list: "th-list",
  cards: "th",
};
